import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import VenuesTranslateView from "../../views/translate/VenuesTranslateView";
import {
  FormUtility,
  withTranslationApi,
  withVenuesApi,
} from "cw-styleguide-react";
import i18n from "../../../../i18n";
import { route } from "../../../../routes";

import { LANGUAGE_EN, TRANSLATOR_UNASSIGNED } from "../../../../constants";
import withAuditApi from "../../../../apis/withAuditApi";

class VenuesTranslateController extends Component {
  /**
   * constructor.
   * @param props
   */
  constructor(props) {
    super(props);

    // State.
    this.state = {
      values: {},
      originalValues: {},
      formErrors: {},
      modals: {
        assign: false,
        bulkAssign: false,
        unassign: false,
        bulkUnassign: false,
      },
      translatableFields: [],
      loaded: false,
      messages: new Set(),
      redirect: null,
      selected: new Set(),
      reloadKey: Math.random(),
      query: ''
    };

    // Binding.
    this.loadVenue = this.loadVenue.bind(this);
    this.saveVenue = this.saveVenue.bind(this);
    this.handleChange = this.handleChange.bind(this);
    //  this.handleSetFormValue = this.handleSetFormValue.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.assignVenue = this.assignVenue.bind(this);
    this.compareVenue = this.compareVenue.bind(this);

    this.handleBulkCheckbox = this.handleBulkCheckbox.bind(this);
    this.clearMessages = this.clearMessages.bind(this);
    this.clearSelected = this.clearSelected.bind(this);
    this.clearRedirect = this.clearRedirect.bind(this);
    this.translateVenueField = this.translateVenueField.bind(this);
    this.translateVenueAll = this.translateVenueAll.bind(this);
    this.setReloadKey = this.setReloadKey.bind(this);
    this.loadAudit = this.loadAudit.bind(this);
    this.setQuery = this.setQuery.bind(this);
  }

  /**
   * setQuery
   * @param value
   */
  setQuery(value) {
    this.setState({
      query: value,
    });
  }

  /**
   * loadAudit
   * @param id
   */
  loadAudit(id) {
    this.props.auditApiGetAudit(
      id,
      "venue",
      i18n.language,
      (response) => {
        this.setState({
          audit: response.data,
        });
      },
      (error) => {
        this.setState({
          audit: false,
        });
      }
    );
  }
  /**
   * Set a new reload key forcing a page refresh.
   */
  setReloadKey() {
    this.setState({
      reloadKey: Math.random(),
    });
  }

  /**
   * handleChange
   * @param event
   */
  handleChange(event) {
    let values = { ...this.state.values };
    this.setState({
      values: FormUtility.setFormValues(event, values),
    });
  }

  /**
   * toggleModal
   * @param id
   */
  toggleModal(ids, visiblity) {
    const modals = { ...this.state.modals };

    // loop through the ids.
    ids.forEach((id) => {
      modals[id] = visiblity;
    });

    this.setState({
      modals: modals,
    });
  }

  /**
   * clearSelected
   */
  clearSelected() {
    this.setState({
      selected: new Set(),
    });
  }

  /**
   * clearMessages
   */
  clearMessages() {
    this.setState({
      messages: new Set(),
      formErrors: {},
    });
  }

  /**
   * clearSelected
   */
  clearRedirect() {
    this.setState({
      redirect: null,
    });
  }

  /**
   * handleBulkCheckbox
   * @param event
   */
  handleBulkCheckbox(event) {
    const selected = this.state.selected;
    if (selected.has(event.target.value)) {
      selected.delete(event.target.value);
    } else {
      selected.add(event.target.value);
    }
    this.setState({
      selected: selected,
    });
  }

  /**
   * saveCourse
   * @param status
   */
  saveVenue(status) {
    // Build the Post JSON.
    let payload = {
      id: this.state.values.id,
      venueName: {
        cy: this.state.values.venueName_cy,
        en: this.state.values.venueName_en,
      },
      addressLine1: {
        cy: this.state.values.addressLine1_cy,
        en: this.state.values.addressLine1_en,
      },
      addressLine2: {
        cy: this.state.values.addressLine2_cy,
        en: this.state.values.addressLine2_en,
      },
      addressLine3: {
        cy: this.state.values.addressLine3_cy,
        en: this.state.values.addressLine3_en,
      },
      addressLine4: {
        cy: this.state.values.addressLine4_cy,
        en: this.state.values.addressLine4_en,
      },
      county: {
        cy: this.state.values.county_cy,
        en: this.state.values.county_en,
      },
      townCity: {
        cy: this.state.values.townCity_cy,
        en: this.state.values.townCity_en,
      },
      postCode: this.state.values.postCode,
      extraFacilities: {
        cy: this.state.values.extraFacilities_cy,
        en: this.state.values.extraFacilities_en,
      },
      facilitiesAvailable: Array.from(this.state.values.facilitiesAvailable),
      learnerSupport: Array.from(this.state.values.learnerSupport),
      status: status,
    };

    // If we have and ID then add it.
    if (this.state.values.id) {
      payload.id = this.state.values.id;
    }

    this.props.venuesApiPostVenue(
      payload,
      i18n.language,
      (response) => {
        // Save the current state of messages.
        let messages = new Set();

        messages.add({
          type: "positive",
          message: i18n.t(
            "local:view.venues.status." + response.data.status + ".success"
          ),
        });

        this.setState({
          formErrors: [],
          redirect: route("venuesTranslateManage") + this.state.query,
        });

        // Set the messages.
        this.setState({ messages: messages });
      },
      (error) => {
        let errors = FormUtility.processServerErrors(error, i18n);
        this.setState({
          formErrors: errors.formErrors,
          messages: errors.messages,
        });
      }
    );
  }

  /**
   * compareCourse
   * @param courseId
   */
  compareVenue(venueId) {
    this.props.venuesApiCompareVenues(
      venueId,
      i18n.language,
      (response) => {
        this.setState({
          translatableFields: response.data.fields ? response.data.fields : [],
        });
      },
      (error) => {
        // @todo what to do here?
      }
    );
  }

  /**
   * loadCourse
   * @param id
   */
  loadVenue(id) {
    this.setState({
      loaded: false,
    });
    this.props.venuesApiGetVenue(
      id,
      i18n.language,
      (response) => {
        this.setState({
          values: {
            id: response.data[0].id,
            venueName_en: response.data[0].venueName.en,
            venueName_cy: response.data[0].venueName.cy,
            townCity_en: response.data[0].townCity.en,
            townCity_cy: response.data[0].townCity.cy,
            extraFacilities_en: response.data[0].extraFacilities.en,
            extraFacilities_cy: response.data[0].extraFacilities.cy,
            learnerSupport: new Set(response.data[0].learnerSupport),
            facilitiesAvailable: new Set(response.data[0].facilitiesAvailable),
            addressLine1_en: response.data[0].addressLine1.en,
            addressLine1_cy: response.data[0].addressLine1.cy,
            addressLine2_en: response.data[0].addressLine2.en,
            addressLine2_cy: response.data[0].addressLine2.cy,
            addressLine3_en: response.data[0].addressLine3.en,
            addressLine3_cy: response.data[0].addressLine3.cy,
            addressLine4_en: response.data[0].addressLine4.en,
            addressLine4_cy: response.data[0].addressLine4.cy,
            county_en: response.data[0].county.en,
            county_cy: response.data[0].county.cy,
            postCode: response.data[0].postCode,
            status: response.data[0].status,
            translatorAssigned: response.data[0].translatorAssigned,
          },
          originalValues: {
            id: response.data[0].id,
            venueName_en: response.data[0].venueName.en,
            venueName_cy: response.data[0].venueName.cy,
            townCity_en: response.data[0].townCity.en,
            townCity_cy: response.data[0].townCity.cy,
            extraFacilities_en: response.data[0].extraFacilities.en,
            extraFacilities_cy: response.data[0].extraFacilities.cy,
            learnerSupport: new Set(response.data[0].learnerSupport),
            facilitiesAvailable: new Set(response.data[0].facilitiesAvailable),
            addressLine1_en: response.data[0].addressLine1.en,
            addressLine1_cy: response.data[0].addressLine1.cy,
            addressLine2_en: response.data[0].addressLine2.en,
            addressLine2_cy: response.data[0].addressLine2.cy,
            addressLine3_en: response.data[0].addressLine3.en,
            addressLine3_cy: response.data[0].addressLine3.cy,
            addressLine4_en: response.data[0].addressLine4.en,
            addressLine4_cy: response.data[0].addressLine4.cy,
            county_en: response.data[0].county.en,
            county_cy: response.data[0].county.cy,
            postCode: response.data[0].postCode,
            status: response.data[0].status,
            translatorAssigned: response.data[0].translatorAssigned,
          },
          loaded: true,
        });
      },
      (error) => {
        let errors = FormUtility.processServerErrors(error, i18n);
        this.setState({
          formErrors: errors.formErrors,
          messages: errors.messages,
          loaded: false,
        });
      }
    );
  }

  /**
   * assignVenue
   * @param ids
   * @param translator
   */
  assignVenue(ids, translator, redirect = true) {
    this.props.venuesApiAssignTranslator(
      ids,
      translator,
      i18n.language,
      (response) => {
        let messages = new Set();

        this.toggleModal(
          ["assign", "bulkAssign", "unassign", "bulkUnassign"],
          false
        );

        if (translator === TRANSLATOR_UNASSIGNED) {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.venues.manage.messages.unassign." +
                (response.data.venueIds.length === 1 ? "singular" : "plural"),
              { count: response.data.venueIds.length }
            ),
          });
        } else {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.venues.manage.messages.assign." +
                (response.data.venueIds.length === 1 ? "singular" : "plural"),
              { count: response.data.venueIds.length }
            ),
          });
        }

        this.setState({
          formErrors: [],
          messages: messages,
          selected: new Set(),
          redirect: redirect ? route("venuesTranslateManage") + this.state.query : null,
          reloadKey: Math.random(),
        });
      },
      (error) => {
        let errors = FormUtility.processServerErrors(error, i18n);

        this.toggleModal(
          ["assign", "bulkAssign", "unassign", "bulkUnassign"],
          false
        );
        this.setState({
          formErrors: errors.formErrors,
          messages: errors.messages,
        });
      }
    );
  }

  /**
   * translateCourseField
   * @param event
   * @param field
   */
  translateVenueField(event, field) {
    event.preventDefault();
    this.props.translationApiPostTranslation(
      "en",
      "cy",
      [
        {
          key: field,
          value: this.state.values[field + "_en"],
        },
      ],
      i18n.language,
      (response) => {
        if (response.data[0].key !== null) {
          const values = { ...this.state.values };

          FormUtility.setDeepValue(
            values,
            field + "_cy",
            response.data[0].value,
            "set"
          );
          this.setState({
            values: values,
          });
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  /**
   * translateCourseAll
   * @param event
   */
  translateVenueAll(event) {
    event.preventDefault();

    let data = [
      {
        key: "venueName",
        value: this.state.values["venueName_en"],
      },
      {
        key: "townCity",
        value: this.state.values["townCity_en"],
      },
      {
        key: "extraFacilities",
        value: this.state.values["extraFacilities_en"],
      },
      {
        key: "addressLine1",
        value: this.state.values["addressLine1_en"],
      },
      {
        key: "addressLine2",
        value: this.state.values["addressLine2_en"],
      },
      {
        key: "addressLine3",
        value: this.state.values["addressLine3_en"],
      },
      {
        key: "addressLine4",
        value: this.state.values["addressLine4_en"],
      },
      {
        key: "county",
        value: this.state.values["county_en"],
      },
    ];

    this.props.translationApiPostTranslation(
      "en",
      "cy",
      data,
      i18n.language,
      (response) => {
        const values = { ...this.state.values };
        response.data.forEach((element, i) => {
          if (element.value !== null) {
            FormUtility.setDeepValue(
              values,
              element.key + "_cy",
              element.value,
              "set"
            );
          }
        });
        this.setState({ values: values });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  /**
   * Render.
   * @returns {JSX.Element}
   */
  render() {
    return (
      <Fragment>
        <VenuesTranslateView
          {...this.state}
          loadVenue={this.loadVenue}
          saveVenue={this.saveVenue}
          handleChange={this.handleChange}
          handleSetFormValue={this.handleSetFormValue}
          toggleModal={this.toggleModal}
          assignVenue={this.assignVenue}
          compareVenue={this.compareVenue}
          handleBulkCheckbox={this.handleBulkCheckbox}
          clearMessages={this.clearMessages}
          clearSelected={this.clearSelected}
          clearRedirect={this.clearRedirect}
          translateVenueField={this.translateVenueField}
          translateVenueAll={this.translateVenueAll}
          setReloadKey={this.setReloadKey}
          loadAudit={this.loadAudit}
          setQuery={this.setQuery}
        />
      </Fragment>
    );
  }
}

export default withAuditApi(process.env)(
  withTranslationApi(process.env)(
    withVenuesApi(process.env)(
      withTranslation("local")(VenuesTranslateController)
    )
  )
);
